<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<onboarding-container [displayProgressBar]="false" (back)="goBack()" [hideForward]="true">
  <p class="zero-text p-huge-med">{{ 'onboarding.savings-plan.top-3-issuer.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'onboarding.savings-plan.top-3-issuer.text' | transloco }}</p>
  <div class="d-block d-sm-flex justify-content-between mt-5 gap">
    @for (issuer of issuers; track issuer.isin) {
      <div class="issuer-box zero-surface grey-800 px-3 py-4 b-r-8 mb-3 mb-sm-0" [class.most-popular]="issuer.mostPopular">
        @if (issuer.mostPopular) {
          <div class="cashback text-nowrap">
            {{ 'onboarding.savings-plan.top-3-issuer.popular-hint' | transloco }}
          </div>
        }
        <div class="text-center zero-text p-bigger-med">{{ issuer.name }}</div>
        <div class="text-center zero-text p-base-med mt-4">
          {{ issuer.ter | number: '1.2-2' }} %
          <web-design-system-icon
            name="info"
            size="small"
            color="dimmed"
            [ngbTooltip]="'onboarding.savings-plan.top-3-issuer.tooltip' | transloco"
          />
        </div>
        <div class="text-center zero-text p-xsmall-reg label">{{ 'onboarding.savings-plan.top-3-issuer.hint' | transloco }}</div>
        <web-design-system-button class="d-block mt-4" size="small" [fullwidth]="true" (click)="selectIssuer(issuer)">
          {{ 'onboarding.savings-plan.top-3-issuer.button' | transloco }}
        </web-design-system-button>
      </div>
    }
  </div>
</onboarding-container>
